import store from "@/store/index";

describe("store", () => {
  it(" creacion del store", () => {
    expect(store).toBeDefined();
  });
});
